import React from "react";
import { Grid } from "semantic-ui-react";

const text_color = "#A9A9A9";

export const TextAligner = (value, unit, strong=false, secondary=false) =>
    <Grid verticalAlign="middle">
        <Grid.Column width={10} style={{ paddingRight: "0.3rem" }}>
            <p style={secondary ? { float: "right", color: text_color } : { float: "right" }}>
                {strong ? <strong>{value}</strong> : value}
            </p>
        </Grid.Column>
        <Grid.Column width={6} style={{ padding: 0 }}>
            <p style={secondary ? { color: text_color, float: "left" } : {}}>
                {strong ? <strong>{unit}</strong> : unit}
            </p>
        </Grid.Column>
    </Grid>


// WEBPACK FOOTER //
// ./src/helpers/text-aligner.js